/**
 * Every regular expression the app uses. The `/g` patterns are only for `.replace`
 * (a global regex keeps state between `.test` calls, so never `.test` with one).
 */
export const REGEX = {
  // ---- input formats
  /** Digits with at most one decimal point, possibly empty ("", "12", "12.5", ".5"). */
  decimal: /^\d*\.?\d*$/,
  /** `decimal`, optionally negative. */
  signedDecimal: /^-?\d*\.?\d*$/,
  wholeNumber: /^\d{1,9}$/,
  fourDigits: /^\d{4}$/,
  upToTwoDigits: /^\d{0,2}$/,
  upToFourDigits: /^\d{0,4}$/,
  /** A ZIP / postal code: 4-6 digits (optional). */
  optionalPostal: /^(\d{4,6})?$/,
  isoDate: /^\d{4}-\d{2}-\d{2}$/,
  phone: /^[0-9+()\-. ]*$/,
  vaultPin: /^\d{4,8}$/,
  oneTimeCode: /^\d{6}$/,
  /** A URL that already names its scheme ("https:", "ftp:", "mailto:"). */
  urlScheme: /^[a-z][a-z0-9+.-]*:/i,

  // ---- text clean-up (for `.replace`)
  nonUppercaseLetters: /[^A-Z]/g,
  nonDigits: /\D/g,
  nonIdChars: /[^\w-]/g,
  trailingSlash: /\/$/,
  trailingCents: /\.\d\d$/,

  // ---- parsing
  /** The file name in a `Content-Disposition` header (group 1). */
  contentDispositionFileName: /filename="?([^";]+)"?/i,
  /** Store paths holding a downloaded Blob (not serialisable, so Redux skips them). */
  mutationBlobPath: /^api\.mutations\.[^.]+\.data\.blob$/,

  // ---- two-step sign-in and sent codes (also read by the e2e suite)
  /** The one-time code in a Password Manager email (group 1). */
  oneTimeCodeInText: /(\d{6})/,
  /** An authenticator-app secret: base32, at least 16 characters. */
  totpSecret: /^[A-Z2-7]{16,}$/,
  /** A two-step recovery code, e.g. "ab12-cd34". */
  recoveryCode: /^[a-z0-9]{4}-[a-z0-9]{4}$/,
  base32Padding: /=+$/,
  /** Eight-character chunks (bits → bytes); for `.match` only. */
  eightCharChunks: /.{8}/g,
} as const;
